import "./EmptyOrder.scss";

interface EmptyOrderProps {
  image: string;
  header: string;
  subHeader: string;
}

const EmptyOrder: React.FC<EmptyOrderProps> = ({
  image,
  header,
  subHeader,
}) => {
  return (
    <div className="empty-order-container">
      <div>
        <img src={image} alt="Empty Order" />
      </div>
      <div className="empty-order-header">{header}</div>

      <div className="empty-order-sub-header">{subHeader}</div>
    </div>
  );
};
export default EmptyOrder;
